import {cookie} from './utilities/cookie';
import {details} from './utilities/details';



// set the GDPR cookies based on input GDPR checkboxs
function cookieSettings(allTrue) {
    const checkboxes = document.querySelectorAll('[data-js="checkbox"]');

    if (checkboxes) {
        var createCookieFromCheckbox = function() {
            for (let i = 0; i < checkboxes.length; i++) {
                let name = checkboxes[i].name;
                let value = checkboxes[i].checked;
                if (allTrue) {
                    value = true;
                    checkboxes[i].checked = true;
                }

                cookie.set(name, value)
            }
        }
        createCookieFromCheckbox(); 
    }
}

// set the checkbox based on cookie GDBR Settings
function checkboxSettings() {
    const checkboxes = document.querySelectorAll('[data-js="checkbox"]');
    if (checkboxes) {
        var updateCheckbox = function() {
            for (let i = 0; i < checkboxes.length; i++) {
                let name = checkboxes[i].name;
                if (cookie.get(name) === 'true') {
                    checkboxes[i].checked = true;
                } else {
                    checkboxes[i].checked = false;
                }
            }
        }
        updateCheckbox(); 
    }
}

export default function gdprManager() {
    const gdprManager = document.querySelector('[data-js="gdpr-manager"]');
    const gdprSettingsBtn = document.querySelector('[data-js="gdpr-settings"]');

    // on document load if the cookies are already accepted set the checkbox as well
    if (cookie.get('consent_cookies') === 'true') {
        checkboxSettings();
    }

    // When gdpr exists
    if (gdprManager) {
        // show GDPR MANAGER
        if (cookie.get('consent_cookies') !== 'true') {
            gdprManager.style.display = 'block';
        }

        // Trigger cookie confirmation
        var trigger = function () {
            function setConsentCookie() {
                if (cookie.get('consent_cookies')) {
                    location.reload();
                } else if (cookie.get('cookie_1') === 'true' || cookie.get('cookie_2') === 'true' || cookie.get('cookie_3') === 'true') {
                    cookie.set('consent_cookies', true)
                    location.reload();
                } else {
                    cookie.set('consent_cookies', true)
                    details.close();
                }
            }
            document.addEventListener('click', function (e) {
                // confirm only choosen cookies
                if (e.target.closest('[data-js="gdpr-confirm"]')) {
                    e.preventDefault();
                    e.target.closest('[data-js="gdpr-manager"]').style.display = 'none';
                    // add cookies
                    cookieSettings();
                    setConsentCookie();
                    
                }

                // confirm all cookies
                if (e.target.closest('[data-js="gdpr-all"]')) {
                    e.preventDefault();
                    e.target.closest('[data-js="gdpr-manager"]').style.display = 'none';
                    // add cokkies
                    cookieSettings(true);
                    setConsentCookie();
                }
            }, false);
        };
        trigger();
    }

    // When gdpr exists
    if (gdprSettingsBtn) {
        // Show an overlay on the gdpr toggler click
        var gdprManagerShow = function () {
            document.addEventListener('click', function (e) {
                if (e.target.closest('[data-js="gdpr-settings"]')) {
                    e.preventDefault();
                    gdprManager.style.display = 'block'
                }
            }, false);
        };
        gdprManagerShow();
    }
}